export default __webpack_public_path__ + "static/media/mainImage3.841a5cee.jpg";